// URL des collections et des livres d'une collection, sans code langue (la langue de l'interface et
// celle du catalogue sont des préférences du visiteur, voir preferences.js) :
//   /izvor/                            page d'accueil ouverte sur « Nos livres », collection Izvor
//   /izvor/p0225fr-harmonie-et-sante   page du livre, fil d'Ariane sur la collection Izvor
// Le segment de collection est le libellé traduit « slugifié » (`Œuvres Complètes` →
// `oeuvres-completes` en français, `complete-works` en anglais) ; le serveur reconnaît le segment
// dans toutes les langues, ainsi que le code API slugifié (`livre-audio`, `tout`).
export const ALL_COLLECTIONS = 'tout';

export function collectionSlug(code) {
  return String(code || '')
    .replace(/œ/gi, 'oe')
    .replace(/æ/gi, 'ae')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

// Segment d'URL d'une collection, traduit : libellé dans la langue de l'interface (`labels`,
// { code: libellé }, voir loadCollectionLabels côté serveur), ex. `Livre audio` → `/audiobook/` en
// anglais. `allLabel` : traduction du site pour « Toutes les collections » quand l'API n'en a pas.
// Libellé sans caractère latin (russe, bulgare, arménien) → segment issu du code.
export function collectionSegment(code, labels = {}, allLabel = '') {
  const label = code === ALL_COLLECTIONS ? labels[code] || allLabel : labels[code];
  return collectionSlug(label) || collectionSlug(code);
}

export function collectionPath(code, labels, allLabel) {
  const segment = collectionSegment(code, labels, allLabel);
  return segment ? `/${segment}/` : '/';
}

// Page d'un produit, dans le contexte d'une collection quand on la connaît (fil d'Ariane), sinon
// l'URL canonique /book/slug.
export function productPath(slug, collectionCode, labels, allLabel) {
  const segment = collectionCode ? collectionSegment(collectionCode, labels, allLabel) : '';
  return segment ? `/${segment}/${slug}` : `/book/${slug}`;
}
